<template>
  <div class="following-section">
    <h4 class="heading squiggly-line-color">Following</h4>
    <div class="following-wrapper" v-if="getFollowingTeachers.length !== 0">
      <div
        class="following-item"
        v-for="teacher in getFollowingTeachers"
        :key="teacher.teacher_id"
      >
        <teacher-card :teacher-data="teacher"></teacher-card>
      </div>
    </div>
    <div v-else>
      <no-content
        :message="message"
        :buttonText="buttonText"
        :is-course="false"
      ></no-content>
    </div>
    <!--<div class="upcoming-live-footer">-->
    <!--<p>-->
    <!--Need help to find your course? or any other questions?-->
    <!--</p>-->
    <!--<b-button size="lg" pill variant="primary">-->
    <!--<span>Talk with an expert</span>-->
    <!--<font-awesome-icon icon="arrow-right" size="xs" />-->
    <!--</b-button>-->
    <!--</div>-->
  </div>
</template>

<script>
import TeacherCard from "../components/Templates/TeacherCard";
import { mapGetters } from "vuex";
import NoContent from "../components/Templates/NoContent";
export default {
  name: "Following",
  components: {
    NoContent,
    TeacherCard
  },
  data() {
    return {
      buttonText: "View Teachers",
      message: "Not Following Any Teachers"
    };
  },
  computed: {
    ...mapGetters("teacher", ["getFollowingTeachers"])
  }
};
</script>

<style scoped></style>
